import { Graphics, Container, Text, Point, ObservablePoint, Texture, extras } from 'pixi.js'
import { grid } from './index'

export default class RoomFloor extends Graphics {

  constructor(room) {
    super()

    // 対象の部屋
    this.room = room

    // テクスチャ
    this.texture = Texture.fromImage(this.room.config.texture_url);

    // スプライト
    this.sprite = new extras.TilingSprite(this.texture, this.room.calcWidth-1, this.room.calcHeight-1);
    this.sprite.position.set(0.5)
    this.sprite.tileScale.x = grid.zoom
    this.sprite.tileScale.y = grid.zoom
    this.addChild(this.sprite)

    if (this.texture.baseTexture.hasLoaded == false) {
      this.room.visible = false
      this.texture.baseTexture.once('loaded', texture => {
        this.room.visible = true
      })
    }

    this.room.on('focus', () => this.focus())
    this.room.on('blur', () => this.blur())

    this.room.on('updatedimension', () => this.updateDimension())
    this.room.on('updatecoordinate', () => this.updateCoordinate())

    this.updateDimension()
    this.updateCoordinate()

    this.interactive = true
    this.cursor = 'grab'

    this.on('pointerdown', e => {
      e.stopPropagation()
      const anchorPosition = e.data.getLocalPosition(this.parent)
      this.room.dragStart(new Point(anchorPosition.x - this.x, anchorPosition.y - this.y))
    })

    return this
  }

  updateDimension() {
    this.clear()
    this.lineStyle(1, 0x666666)
    this.beginFill(0x66ff66, 0.75)
    this.drawRect(0, 0, this.room.calcWidth, this.room.calcHeight)

    this.sprite.width = this.room.calcWidth-1
    this.sprite.height = this.room.calcHeight-1
    this.sprite.tileScale.set(grid.zoom, grid.zoom)
  }

  updateCoordinate() {
    this.position.set(this.room.position.x, this.room.position.y)
  }

  focus() {
    this.sprite.alpha = 0.25
  }

  blur() {
    this.sprite.alpha = 1
  }
}



// WEBPACK FOOTER //
// ./assets/js/display/RoomFloor.js